const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M72.0259 0H0V72H72.0259V0Z",
  fill: "#0076FF"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m51.675 37.466c-1.1798 0-2.1732 0.9931-2.1732 2.1724s0.9313 2.1103 2.1732 2.1103c1.1797 0 2.1111-0.931 2.1111-2.1103 0.0621-1.1793-0.9314-2.1724-2.1111-2.1724zm0 6.6414c-2.4837 0-4.5327-1.9863-4.5327-4.469 0-2.4828 2.049-4.469 4.5327-4.469 2.4836 0 4.4706 1.9862 4.4706 4.469 0.062 2.4827-1.987 4.469-4.4706 4.469z",
  fill: "#F6FAFF"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m35.492 55.738h-2.3586v-8.069h2.3586v8.069z",
  fill: "#F6FAFF"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m38.907 55.738h-2.3586v-8.069h2.3586v8.069z",
  fill: "#F6FAFF"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m46.34 20.23 2.2974-2.2965-1.6765-1.6759-2.2974 2.2966-1.6764 1.6758 2.9803 2.9794-2.2973 2.2965 1.6764 1.6759 3.9739-3.9724-2.9804-2.9794z",
  fill: "#F6FAFF"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m20.179 39.375 1.3861 2.3761h-2.7743l1.3882-2.3761zm0-4.6598-5.4545 9.4267h10.909l-5.4545-9.4267z",
  fill: "#F6FAFF"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m30.544 18.802-1.6764-1.6759-2.8563 2.8552-2.8561-2.8552-1.6765 1.6759 2.8562 2.8551-2.8562 2.8552 1.6765 1.6759 2.8561-2.8552 2.8563 2.8552 1.6764-1.6759-2.8562-2.8552 2.8562-2.8551z",
  fill: "#F6FAFF"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m97.258 31.484v-2.6928h-1.9173v-6.0192h1.9173v-2.6453h-6.6552v2.6453h1.9173v6.0192h-1.9173v2.6928h6.6552z",
  fill: "#00244D"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m101.37 26.684c0-1.2672 0.412-2.0909 1.505-2.0909 1.062 0 1.347 0.7286 1.347 1.8691v5.0213h2.915v-5.845c0-2.2176-1.077-3.5323-3.121-3.5323-1.426 0-2.377 0.6811-2.852 1.7424l-0.27-1.5523h-2.4559v9.1872h2.9319v-4.7995z",
  fill: "#00244D"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m113.6 31.484 3.566-9.1872h-2.979l-1.87 5.5757-1.838-5.5757h-2.963l3.422 9.1872h2.662z",
  fill: "#00244D"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m121.8 24.293c1.078 0 1.617 0.602 1.743 1.6316h-3.628c0.19-1.0772 0.808-1.6316 1.885-1.6316zm4.532 4.2768h-3.058c-0.222 0.5228-0.666 0.8712-1.474 0.8712-1.109 0-1.743-0.6019-1.885-1.7107h6.48v-1.0296c0-2.4869-1.378-4.5936-4.626-4.5936-2.869 0-4.722 1.7899-4.722 4.7362v0.2693c0 2.8353 1.489 4.6094 4.674 4.6094 2.678 0 4.104-1.2197 4.611-3.1522z",
  fill: "#00244D"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m131.55 31.737c2.852 0 4.247-1.3622 4.247-3.1996 0-2.1384-1.902-2.5344-3.486-2.7404-1.363-0.1742-2.139-0.2692-2.139-0.8395 0-0.4435 0.317-0.7761 1.204-0.7761 0.871 0 1.347 0.3484 1.474 0.982h2.836c-0.285-1.8374-1.521-3.0729-4.278-3.0729-2.599 0-4.009 1.2513-4.009 3.0413 0 2.1859 1.869 2.5344 3.454 2.7403 1.141 0.1425 2.139 0.2217 2.139 0.8553 0 0.5069-0.396 0.8079-1.299 0.8079-0.935 0-1.505-0.3485-1.696-1.1247h-2.979c0.301 2.1226 1.791 3.3264 4.532 3.3264z",
  fill: "#00244D"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m142.68 28.807h-0.586c-1.363 0-1.6-0.1742-1.6-1.7582v-2.2018h2.186v-2.5502h-2.186v-2.2968h-2.377c-0.016 0.3802-0.048 0.8712-0.095 1.2514-0.095 0.7761-0.317 1.0296-0.903 1.1088-0.317 0.0633-0.555 0.095-0.904 0.095v2.3918h1.553v2.772c0 2.8671 0.682 3.865 3.455 3.865h1.457v-2.677z",
  fill: "#00244D"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m148.01 31.722c2.804 0 4.643-1.5523 4.643-4.6094v-0.2852c0-3.0729-1.87-4.7203-4.627-4.7203-2.71 0-4.643 1.5999-4.643 4.7203v0.2852c0 3.0571 1.648 4.6094 4.627 4.6094zm0.016-2.4869c-1.062 0-1.775-0.7445-1.775-2.1542v-0.2535c0-1.5364 0.713-2.2809 1.79-2.2809 1.11 0 1.743 0.7761 1.743 2.2809v0.2535c0 1.4414-0.697 2.1542-1.758 2.1542z",
  fill: "#00244D"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m156.83 31.484v-4.0709c0-1.6315 0.412-2.2176 2.091-2.2176h1.078v-3.0254h-0.523c-1.648 0-2.583 0.5861-2.884 2.0117l-0.396-1.885h-2.313v9.1872h2.947z",
  fill: "#00244D"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m96.608 47.304h-2.3135l1.1409-3.6907 1.1726 3.6907zm1.3944 4.3402h2.9153l-3.9928-11.357h-2.9473l-3.9456 11.357h2.9315l0.618-1.9958h3.7871l0.6338 1.9958z",
  fill: "#00244D"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m105.66 51.882c2.677 0 4.516-1.2355 4.627-4.1184v-0.0792h-2.995v0.0317c-0.095 1.1563-0.666 1.679-1.617 1.679-1.045 0-1.711-0.7445-1.711-2.1542v-0.2535c0-1.5364 0.666-2.2809 1.727-2.2809 0.951 0 1.49 0.491 1.585 1.6157v0.0633h2.995v-0.0475c-0.111-2.8037-1.934-4.0709-4.596-4.0709-2.693 0-4.642 1.5999-4.642 4.7203v0.2852c0 3.0571 1.663 4.6094 4.627 4.6094z",
  fill: "#00244D"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "m115.79 51.882c2.678 0 4.516-1.2355 4.627-4.1184v-0.0792h-2.995v0.0317c-0.095 1.1563-0.665 1.679-1.616 1.679-1.046 0-1.711-0.7445-1.711-2.1542v-0.2535c0-1.5364 0.665-2.2809 1.727-2.2809 0.951 0 1.489 0.491 1.584 1.6157v0.0633h2.995v-0.0475c-0.111-2.8037-1.933-4.0709-4.595-4.0709-2.694 0-4.643 1.5999-4.643 4.7203v0.2852c0 3.0571 1.664 4.6094 4.627 4.6094z",
  fill: "#00244D"
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "m125.93 51.882c2.805 0 4.643-1.5523 4.643-4.6094v-0.2852c0-3.0729-1.87-4.7203-4.627-4.7203-2.71 0-4.643 1.5999-4.643 4.7203v0.2852c0 3.0571 1.648 4.6094 4.627 4.6094zm0.016-2.4869c-1.062 0-1.775-0.7445-1.775-2.1542v-0.2535c0-1.5364 0.713-2.2809 1.791-2.2809 1.109 0 1.743 0.7761 1.743 2.2809v0.2535c0 1.4414-0.698 2.1542-1.759 2.1542z",
  fill: "#00244D"
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "m137.81 51.644h2.44v-9.1872h-2.931v4.7837c0 1.2355-0.381 2.075-1.395 2.075-1.03 0-1.283-0.7445-1.283-1.8691v-4.9896h-2.884v5.845c0 2.2334 0.998 3.5164 3.042 3.5164 1.379 0 2.282-0.6652 2.741-1.7265l0.27 1.5523z",
  fill: "#00244D"
});
var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "m144.76 46.844c0-1.2672 0.412-2.0909 1.505-2.0909 1.062 0 1.347 0.7286 1.347 1.8691v5.0213h2.915v-5.845c0-2.2176-1.077-3.5323-3.121-3.5323-1.426 0-2.377 0.6811-2.852 1.7424l-0.27-1.5523h-2.456v9.1872h2.932v-4.7995z",
  fill: "#00244D"
});
var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "m157.7 48.967h-0.586c-1.363 0-1.601-0.1742-1.601-1.7582v-2.2018h2.187v-2.5502h-2.187v-2.2968h-2.377c-0.015 0.3802-0.047 0.8712-0.095 1.2514-0.095 0.7761-0.317 1.0296-0.903 1.1088-0.317 0.0633-0.554 0.095-0.903 0.095v2.3918h1.553v2.772c0 2.8671 0.681 3.865 3.454 3.865h1.458v-2.677z",
  fill: "#00244D"
});
function SvgLogoHeaderLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeaderLight);
export default __webpack_public_path__ + "static/media/logo_header_light.5bbc186e.svg";
export { ForwardRef as ReactComponent };